import pointsWithinPolygon from '@turf/points-within-polygon';
import circle from '@turf/circle';
import moment from 'moment';
import { get } from 'lodash-es';
import { arrayToFeatureCollection } from 'utils/geojson';
import { decodeHtmlCharCodes } from 'utils/strings';

const eventUrl =
  'https://www.womenssportsfoundation.org/wp-json/wp/v2/wsf-event?per_page=100';

const fetchJson = async url => {
  const resp = await fetch(url);
  return resp.json();
};

export const fetchCoordinates = async address => {
  if (!address) return null;
  const json = await fetchJson(
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${address}.json?access_token=${__MAPBOX_KEY__}`,
  );
  return get(json, 'features[0].center');
};

const normalizeEvents = json =>
  json.reduce(async (acc, { acf, id, title }) => {
    const accRes = await acc;
    const {
      brief_description,
      event_address,
      event_date,
      event_location,
      website_for_event_information,
    } = acf;
    const lng = get(event_address, 'lng');
    const lat = get(event_address, 'lat');
    let coordinates = [lng, lat];
    if (!lat || !lng) {
      coordinates = await fetchCoordinates(event_location);
    }
    if (!coordinates) return accRes;
    try {
      coordinates = coordinates.map(coord =>
        Number.parseFloat(coord),
      );
    } catch (e) {
      return accRes;
    }

    return [
      {
        address: get(event_address, 'address'),
        coordinates,
        date: moment(event_date, 'MM-DD-YYYY').format('MMMM Do YYYY'),
        description: brief_description,
        href: website_for_event_information,
        id,
        location: event_location,
        title: decodeHtmlCharCodes(get(title, 'rendered')),
      },
      ...accRes,
    ];
  }, []);

export const fetchEvents = async () => {
  const res = await fetch(eventUrl);
  const totalPages = res.headers.get('x-wp-totalpages');
  let json = await res.json();
  if (totalPages > 1) {
    json = await new Array(totalPages - 1)
      .fill('')
      .reduce(async (acc, _, i) => {
        const nextAcc = await acc;
        const nextPage = await fetchJson(`${eventUrl}&page=${i + 2}`);
        return [...nextAcc, ...nextPage];
      }, json);
  }
  return normalizeEvents(json);
};

export const fetchEventsByZipcode = async (zipcode, radius) => {
  const events = await fetchEvents();
  const zipcodeCoordinates = await fetchCoordinates(zipcode);
  const CirlceOfConcern = circle(zipcodeCoordinates, radius, {
    units: 'miles',
  });
  const Points = arrayToFeatureCollection(events);
  const RelevantPoints = pointsWithinPolygon(Points, CirlceOfConcern);
  return RelevantPoints.features.map(feature => feature.properties);
};
